<div [matTooltip]="'Text'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    class="text-[18px]"
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-text'"
    (click)="selectTool.emit()"
  >
    <fa-icon [icon]="['fal', 'text-size']"></fa-icon>
  </button>
</div>
